import { render, staticRenderFns } from "./PriceWaterStrage.vue?vue&type=template&id=051ed4b0&scoped=true&"
import script from "./PriceWaterStrage.vue?vue&type=script&lang=js&"
export * from "./PriceWaterStrage.vue?vue&type=script&lang=js&"
import style0 from "./PriceWaterStrage.vue?vue&type=style&index=0&id=051ed4b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "051ed4b0",
  null
  
)

export default component.exports